import { useConnectAndDisconnectProxiesMutation, useGetProxyRouterIdsQuery } from "@RTKQuery/admin/proxy/proxy";
import style from "./SettingsRouter.module.scss";
import cn from "classnames";
import { RiLoader5Fill } from "react-icons/ri";
import { Button, Input, proxyNumber } from "@ui";
import { useEffect, useState } from "react";
import { IProxy } from "@interfaces/admin/proxy";
import { IoClose } from "react-icons/io5";

export function SettingsRouter({
    isOpen,
    close,
    proxyId
}: {
    isOpen: boolean,
    close: () => void,
    proxyId: IProxy["id"]
}) {
    const { data } = useGetProxyRouterIdsQuery();

    const [connectAndDisconnectProxies, status] = useConnectAndDisconnectProxiesMutation();

    const [activeParentId, setActiveParentId] = useState<IProxy["id"]>();
    const [deleteChildrenIds, setDeleteChildrenIds] = useState<IProxy["id"][]>([]);
    const [addChildrenIds, setAddChildrenIds] = useState<IProxy["id"][]>([]);

    const [searchId, setSearchId] = useState<IProxy["id"]>();

    useEffect(() => {
        setActiveParentId(proxyId);
    }, [proxyId])

    useEffect(() => {
        setAddChildrenIds(data?.find(item => item.router_id === activeParentId)?.children_ids || [])
    }, [activeParentId, data])

    function deleteChildrenId(id: IProxy["id"]) {
        setAddChildrenIds(state => state.filter(item => item !== id));
        setDeleteChildrenIds(state => [...state, id])
    }

    function addChildrenId(id: IProxy["id"]) {
        setDeleteChildrenIds(state => state.filter(item => item !== id));
        setAddChildrenIds(state => [...state, id])
    }

    return (
        <div
            onClick={(e) => {
                if (e.target === e.currentTarget) {
                    close()
                }
            }}
            className={cn(style.backing, isOpen ? "flex" : "hidden")}
        >
            <div className={style.container}>
                <p className={style.label}>Налаштування</p>
                {
                    !data
                        ? <div><RiLoader5Fill className="animate-spin w-[30px] h-[30px]" /></div>
                        : <>
                            <div className="flex items-start max-h-full min-h-0 grow justify-between mb-[20px] gap-[40px] max-sm:flex-col max-sm:overflow-auto max-sm:pr-[15px]">
                                <div className="flex flex-col gap-[20px] grow w-[270px] max-h-full max-sm:max-h-[300px]">
                                    <p className={style.text}>Редагування модему: <span className="font-bold text-[18px]">{activeParentId}</span></p>
                                    <p className={style.text}>Підключені модеми:</p>
                                    <div className="flex flex-col overflow-auto max-h-full min-h-0 gap-[15px] pr-[5px]">
                                        {
                                            addChildrenIds.map((item, i) => (
                                                <div key={i} className="flex justify-between items-center">
                                                    <p className={style.childrenId}>id: {item}</p>
                                                    <div className={style.deleteButton}>
                                                        <IoClose
                                                            className="w-[16px] h-[16px]"
                                                            onClick={() => {
                                                                deleteChildrenId(item)
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                                <div className="flex flex-col gap-[20px] max-h-full min-h-0 grow w-[270px]">
                                    <Input
                                        value={String(searchId || "")}
                                        onChange={(value) => {
                                            setSearchId(Number(value))
                                        }}
                                        customStyle={{
                                            width: "!max-w-full !w-full"
                                        }}
                                        label="Пошук по id"
                                    />
                                    <div className={style.listFreeIds}>
                                        <div className="flex flex-col overflow-auto max-h-full min-h-0 gap-[15px]">
                                            {
                                                data.map(item => {
                                                    if (item.parent_id || item.children_ids.length || addChildrenIds.includes(item.router_id) || (item.router_id === activeParentId)) {
                                                        return null
                                                    } else {
                                                        if (searchId) {
                                                            if (proxyNumber(item).includes(String(searchId))) {
                                                                return <p key={item.id} onClick={() => addChildrenId(item.router_id)} className={style.freeId}>№{proxyNumber(item)}</p>
                                                            } else {
                                                                return null
                                                            }
                                                        } else {
                                                            return <p key={item.id} onClick={() => addChildrenId(item.router_id)} className={style.freeId}>№{proxyNumber(item)}</p>
                                                        }
                                                    }
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Button
                                color="orange"
                                form="ellipse"
                                text={
                                    status.isSuccess
                                    ? "Успішно збережено"
                                    : "Зберегти"
                                }
                                disabled={!activeParentId}
                                loading={status.isLoading}
                                customStyle={{
                                    button: style.customBtn,
                                }}
                                errors={[
                                    (status.error && ((extractError) => {
                                        return extractError(status.error)
                                    }))
                                ]}
                                onClick={() => {
                                    connectAndDisconnectProxies({
                                        parent_proxy_id: Number(activeParentId),
                                        connect_router_ids: addChildrenIds,
                                        disconnect_router_ids: deleteChildrenIds
                                    });
                                }}
                                resetStatus={() => {
                                    status.reset();
                                }}
                            />
                        </>
                }
            </div>
        </div>
    )
}